import { render, staticRenderFns } from "./ClientsObjects.vue?vue&type=template&id=8769e4b0"
import script from "./ClientsObjects.vue?vue&type=script&lang=js"
export * from "./ClientsObjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports